<!-- =========================================================================================
  File Name: DataListListView.vue
  Description: Data List - List View
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="data-list-list-view" class="data-list-container">

    <data-view-sidebar :isSidebarActive="addNewDataSidebar" @closeSidebar="toggleDataSidebar" :data="sidebarData" v-if="addNewDataSidebar"/>

    <vs-table v-if="permissions_list" ref="table" pagination :max-items="itemsPerPage" search :data="users">

      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

        <div class="flex flex-wrap-reverse items-center data-list-btn-container">

          <!-- ACTION - DROPDOWN -->
          <!-- <vs-dropdown vs-trigger-click class="dd-actions cursor-pointer mr-4 mb-4">

            <div class="p-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-center text-lg font-medium w-32 w-full">
              <span class="mr-2">Actions</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>

            <vs-dropdown-menu>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="TrashIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Delete</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="ArchiveIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Archive</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="FileIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Print</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="SaveIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Another Action</span>
                </span>
              </vs-dropdown-item>

            </vs-dropdown-menu>
          </vs-dropdown> -->

          <!-- ADD NEW -->
          <vs-button :size="largeScreenWidth ? '' : 'small' " color="primary" type="filled" @click="addNewData" v-if="permissions_create" icon="icon-plus" icon-pack="feather">Add New</vs-button>
          <!-- <div class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary btn-sm" @click="addNewData" v-if="permissions_create">
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
              <span class="ml-2 text-base text-primary">Add New</span>
          </div> -->
        </div>

        <!-- ITEMS PER PAGE -->
        <vs-dropdown :disabled="users.length == 0" vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
          <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <span v-if="users.length > 0" class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ users.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : users.length }} of {{ queriedItems }}</span>
            <span v-else>0 of 0</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>
            <vs-dropdown-item @click="itemsPerPage=10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=15">
              <span>15</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=20">
              <span>20</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=25">
              <span>25</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <!-- <vs-th sort-key="groupid">Group</vs-th> -->
        <vs-th sort-key="name">Name</vs-th>
        <vs-th sort-key="role">Role</vs-th>
        <vs-th sort-key="company_code">Company Code</vs-th>
        <vs-th sort-key="primary_contact">Contact</vs-th>
        <vs-th sort-key="status">Status</vs-th>
        <vs-th sort-key="updated_at">Last Updated</vs-th>
        <vs-th v-if="permissions_update || permissions_delete">Action</vs-th>
      </template>

        <template slot-scope="{data}">
          <tbody>
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td>
                <p class="name font-medium truncate">{{ tr.name }}</p>
              </vs-td>

              <vs-td>
                <p class="role">{{ tr.role }}</p>
              </vs-td>
              <vs-td>
                <p class="company_code">{{ tr.company_code }}</p>
              </vs-td>
              <vs-td>
                <p class="primary_contact">{{ tr.primary_contact }}</p>
              </vs-td>

              <vs-td>
                <p class="status">
                  <vs-chip :color="tr.status == 'ACTIVE' ? 'primary' : 'danger'">{{ tr.status }}</vs-chip>
                </p>
              </vs-td>

              <vs-td>
                <p class="updated_at">{{ formatDate(tr.updated_at) }}</p>
              </vs-td>

              <!-- <vs-td>
                <vs-progress :percent="Number(tr.popularity)" :color="getPopularityColor(Number(tr.popularity))" class="shadow-md" />
              </vs-td>

              <vs-td>
                <vs-chip :color="getOrderStatusColor(tr.order_status)" class="order-status">{{ tr.order_status | title }}</vs-chip>
              </vs-td> -->

              <!-- <vs-td>
                <p class="price">${{ tr.price }}</p>
              </vs-td> -->

              <vs-td class="whitespace-no-wrap" v-if="permissions_update || permissions_delete">
                <feather-icon v-if="permissions_update && user_info.id !== tr.uuid" icon="KeyIcon" svgClasses="w-5 h-5 text-primary stroke-current" @click.stop="resetPassword(tr)" />
                <feather-icon v-if="permissions_update && user_info.id !== tr.uuid" icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" class="ml-4" @click.stop="editData(tr)" />
                <feather-icon v-if="permissions_delete && user_info.id !== tr.uuid" :icon="classObject(tr.status)" :svgClasses="svgClass(tr.status)" class="ml-4" @click.stop="updateStatus(tr)" />
              </vs-td>

            </vs-tr>
          </tbody>
        </template>
    </vs-table>
    <h5 v-else>Not allowed to view user list</h5>

    <vs-popup title="Reset Password" :active.sync="popupActive">
      <vs-input label="New Password/新密码" v-model="reset_new_pass" class="mt-5 mb-5 w-full" />
      <div class="flex flex-wrap items-center">
      <vs-button class="mr-6" @click="reset">Reset</vs-button>
      <vs-button type="border" color="danger" @click="popupActive = false">Cancel</vs-button>
    </div>
    </vs-popup>
  </div>
</template>

<script>
import DataViewSidebar from './sidebar.vue'
// Store Module
import moduleUserManagement from '@/store/user-management/moduleUserManagement.js'

export default {
  components: {
    DataViewSidebar
  },
  data () {
    return {
      // selected: [],
      // users: [],
      itemsPerPage: 10,
      isMounted: false,

      // Data Sidebar
      addNewDataSidebar: false,
      sidebarData: {},

      popupActive: false,
      reset_uuid: {},
      reset_new_pass: ''
    }
  },
  computed: {
    largeScreenWidth(){
      if(window.innerWidth > 575){
        return true
      }
      else
        return false
    },
    currentPage () {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
    // aaa(){
    //   return this.$store.state.AppActiveUser
    // },
    permissions () {
      if(this.$store.state.AppActiveUser && this.$store.state.AppActiveUser.permissions){
        return this.$store.state.AppActiveUser.permissions;
      }
      else{
        return []
      }
    },
    permissions_create(){
      if( this.permissions.includes('*') || this.permissions.includes('011')){
        return true
      }
      else{
        return false
      }
    },
    permissions_list(){
      if( this.permissions.includes('*') || this.permissions.includes('012')){
        return true
      }
      else{
        return false
      }
    },
    permissions_update(){
      if( this.permissions.includes('*') || this.permissions.includes('013')){
        return true
      }
      else{
        return false
      }
    },
    permissions_delete(){
      if( this.permissions.includes('*') || this.permissions.includes('014')){
        return true
      }
      else{
        return false
      }
    },
    users () {
      return this.$store.state.userManagement.users.filter(function(item){
        return item.role !== 'DEVELOPER'
      })
    },
    user_info(){
      let data = JSON.parse(sessionStorage.getItem('userInfo'));
      return data
    },
    queriedItems () {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.users.length
    }
  },
  methods: {
    classObject(status){
      if(status == 'ACTIVE'){
        return 'LockIcon'
      }
      else{
        return 'UnlockIcon'
      }
    },
    svgClass(status){
      if(status == 'ACTIVE'){
        return 'w-5 h-5 stroke-current text-danger'
      }
      else{
        return 'w-5 h-5 stroke-current text-success'
      }
    },
    addNewData () {
      this.sidebarData = {}
      this.toggleDataSidebar(true)
    },
    updateStatus (data) {
      let self = this
      let new_status = data.status == 'ACTIVE' ? 'INACTIVE' : 'ACTIVE'
      this.$vs.dialog({
        type: 'confirm',
        color: 'warning',
        title: 'Confirm Update Status',
        text: `You are about to set "${data.name}" to "${new_status}"`,
        acceptText: 'Confirm',
        accept: function(){
          let formData = new FormData();        
          formData.append('_method', 'PUT' )
          formData.append('status', data.status == 'ACTIVE' ? 'INACTIVE' : 'ACTIVE' )

          let obj = {
            uuid: data.uuid,
            form_data: formData
          }
          self.$store.dispatch('userManagement/updateStatus', obj).catch(err => { console.error(err) })
        }
      })
    },
    resetPassword(data){
      this.reset_uuid = data
      this.popupActive = true
    },
    reset(){
      let self = this
      if(this.reset_new_pass=="")
        return false
      this.$vs.dialog({
        type: 'confirm',
        color: 'warning',
        title: 'Confirm Reset Password',
        text: `You are about to set new password for ${this.reset_uuid.name}?`,
        acceptText: 'Confirm',
        accept: function(){
          self.$vs.loading()
          const baseURI = 'users/set_password/'+self.reset_uuid.uuid
          let formData = new FormData();
          formData.append('new_password', self.reset_new_pass);

          self.$http.post(baseURI,formData)
          .then((result) => {
            if(result.data.status == 'success'){
              self.popupActive = false
              self.reset_new_pass=""
              self.$vs.loading.close()
              self.$vs.notify({
                iconPack: 'feather',
                icon: 'icon-check-circle',
                color: 'success',
                title: 'Reset password successful'
              })
            }
          })
        }
      })
      
    },
    editData (data) {
      // this.sidebarData = JSON.parse(JSON.stringify(this.blankData))
      this.sidebarData = data
      this.toggleDataSidebar(true)
    },
    toggleDataSidebar (val = false) {
      this.addNewDataSidebar = val
      // this.$store.dispatch("userManagement/fetchUsers")
    }
  },
  created () {
    
    if (!moduleUserManagement.isRegistered) {
      this.$store.registerModule('userManagement', moduleUserManagement)
      moduleUserManagement.isRegistered = true
    }
    if(this.permissions_list){
      this.$vs.loading()

      this.$store.dispatch('userManagement/fetchUsers').then((data) => {
        this.$vs.loading.close()
      }).catch(err => { 
        if(err.logout){
          this.$vs.loading.close()
          this.$vs.notify({
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger',
            title: err.msg
          })
          sessionStorage.removeItem('accessToken')
          sessionStorage.removeItem('user')
          this.$router.push('/pages/login').catch(() => {})
        }
        console.error(err,'userManagement/fetchUsers') 
      })
    }
  },
  mounted () {
    this.isMounted = true
  }
}
</script>

<style lang="scss">
.con-vs-popup .vs-popup{
  width:450px;
}
.con-vs-dialog{
  z-index:55000;
}
#data-list-list-view {
  .vs-con-table {

    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search{
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr{
          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
          td{
            padding: 20px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
          }
          td.td-check{
            padding: 20px !important;
          }
      }
    }

    .vs-table--thead{
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text{
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check{
        padding: 0 15px !important;
      }
      tr{
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
